<script>
import yesnoRenderer from '@/views/components/renderers/yesno-renderer'
export default {
  components: {  
    yesnoRenderer
  },
  created() {
    
  },
  computed: {
    value() {
      return this.params.getValue();
    }
  }
};
</script>

<template>
  <yesno-renderer :value="value"></yesno-renderer>
</template>
